import { useCallback } from 'react';
import keyBy from 'lodash/keyBy';
import { useGroupIdsByTicketTypeIdSubscriber } from '../../services/store';
import useGroupList from '../groups-resource';

const useGetGroupsByTicketType = (ticketTypeId: number) => {
	const groups = useGroupList();
	const [groupIds] = useGroupIdsByTicketTypeIdSubscriber(ticketTypeId);

	const getNames = useCallback((): string[] => {
		if (groupIds) {
			const groupsMap = keyBy(groups, 'id');
			// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/js/no-reduce-accumulator-spread
			return groupIds.reduce<Array<any>>((acc, id) => [...acc, groupsMap[id].name], []);
		}

		return [];
	}, [groupIds, groups]);

	return [groupIds, getNames] as const;
};

export default useGetGroupsByTicketType;
